/**
 * Origem do pedido — rótulo, cor e ícone, num lugar só.
 *
 * As origens são as do backend (`Pedido::ORIGEM` em zaper-api): gestor, cardapio,
 * tablet, ifood e amo. O mapa vivia duplicado dentro do relatório de vendas; agora que
 * a origem aparece também no card, no diálogo da comanda e nos filtros da home,
 * manter uma cópia por tela garantiria que uma delas ficasse para trás.
 */

export const ORIGENS = {
    gestor: {
        valor: 'gestor',
        label: 'PDV',
        color: 'orange',
        icone: 'mdi-cash-register',
    },
    cardapio: {
        valor: 'cardapio',
        label: 'Cardápio Digital',
        color: 'blue',
        icone: 'mdi-cellphone',
    },
    tablet: {
        valor: 'tablet',
        label: 'Tablet',
        color: 'teal',
        icone: 'mdi-tablet',
    },
    ifood: {
        valor: 'ifood',
        label: 'iFood',
        color: 'red darken-1',
        icone: 'mdi-moped',
        logo: 'ifood-logo.png',
        marketplace: true,
    },
    amo: {
        valor: 'amo',
        label: 'Amo Delivery',
        color: 'deep-purple',
        icone: 'mdi-storefront-outline',
        logo: 'amo-logo.png',
        marketplace: true,
    },
};

/** Ordem de exibição em filtros — do mais comum ao menos. */
export const ORIGENS_LISTA = [
    ORIGENS.gestor,
    ORIGENS.cardapio,
    ORIGENS.tablet,
    ORIGENS.ifood,
    ORIGENS.amo,
];

/**
 * Descobre a origem de um pedido.
 *
 * Pedido antigo não tem a coluna `origem` preenchida — nesses, o booleano `app`
 * distingue o que veio do cardápio digital do que foi lançado no balcão. Sem esse
 * atalho, todo o histórico apareceria como PDV.
 */
export function origemInfo(pedido) {
    const chave = pedido?.origem;

    if (chave && ORIGENS[chave]) {
        return ORIGENS[chave];
    }

    return pedido?.app ? ORIGENS.cardapio : ORIGENS.gestor;
}

export function ehDoTablet(pedido) {
    return origemInfo(pedido).valor === ORIGENS.tablet.valor;
}

export function ehDeMarketplace(pedido) {
    return origemInfo(pedido).marketplace === true;
}

export function logoDaOrigem(pedido) {
    return origemInfo(pedido).logo || null;
}
